module.exports = __webpack_public_path__ + "static/media/logo_amazing.e516844f.png";